const FirstContact = `
  id
  description
  updatedAt
`;

export default FirstContact;
